import { loginReasons, LoginRedirectParams } from '@modules/base/auth';
import { StorageData } from '@modules/pages/mortgage-survey/survey';

type StoredValues = {
  isLoggedIn: boolean;
  'mortgage-survey': StorageData;
};

class LocalStorage {
  constructor() {
    if (!localStorage) throw Error('LocalStorage is not available');
  }

  getItem<T extends keyof StoredValues>(key: T): StoredValues[T] | undefined {
    const value = localStorage.getItem(key);
    if (!value) return;

    return JSON.parse(value);
  }

  setItems(items: Partial<StoredValues>) {
    for (const [key, value] of Object.entries(items)) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }
}

export let storage: LocalStorage;
if (typeof window !== 'undefined') storage = new LocalStorage();

type EventHandlers = {
  handleLoginRedirect: (params: LoginRedirectParams) => void;
  handleLoggedInRedirect: () => void;
};

/*
 * LocalStorage events are used for sharing states between browser tabs
 *
 * "event only get picked up (by the listener) if the localStorage was changed in another browser's tab/window"
 * source: https://stackoverflow.com/a/65348883/11374998
 */
export function initStorageEventHandler(handlers: EventHandlers) {
  return function storageEventHandler(
    this: EventHandlers,
    event: StorageEvent,
  ) {
    switch (event.key) {
      case 'isLoggedIn': {
        if (event.newValue === 'false')
          this.handleLoginRedirect({ reason: loginReasons.session_expired });
        else this.handleLoggedInRedirect();
      }
    }
  }.bind(handlers);
}
